<div class="row mb-4">
    <div class="col-md-12">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a href="#">Tickets</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Criar novo</li>
            </ol>
        </nav>
    </div>
    <div class="col-md-12 title-page">
        <h2>Ticket #{{ticketId}}</h2>
    </div>
</div>
<form class="row mb-4" [formGroup]="realDeskForm"  (keydown)="onFormKeyDown($event)">
    <div class="col-md-3">
        <div class="card content">

            <!-- Solicitante -->
            <div *ngIf="!isChat && !whatsAppEmAtendimento">
              <h3>
                  Solicitante
                  <a href="javascript:void()" (click)="mofiModal()" class="btn btn-link icon"
                   matTooltip="Adicione um novo cliente solicitante a este ticket. Caso esse solicitante já seja cliente, é melhor buscá-lo na caixa de texto abaixo."
                  >
                      <span>
                          <img src="../../../../assets/images/icon-plus.svg">
                      </span>
                      Adicionar novo cliente
                  </a>
              </h3>
              <div class="col-md-12 mb-3 search-bar" style="margin-left:0"
                 matTooltip="Comece a digitar o nome de um cliente existente e sera apresentado uma lista de clientes."
              >
                  <input
                      type="text"
                      class="form-control"
                      placeholder="Pesquisar nome ou informação da pessoa"
                      style="width:100%;"
                      matInput formControlName="autocompleteControl" [matAutocomplete]="autoSolicitante"
                  >
                    <mat-autocomplete autoActiveFirstOption #autoSolicitante="matAutocomplete" (optionSelected)="onOptionSelected($event)" [displayWith]="displayFn">
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                          <div class="d-flex flex-column p-2">
                            <div class="fw-semibold text-primary mb-1">{{option.nome}}</div>
                            <div class="d-flex flex-column gap-1">
                                <div class="text-muted small d-flex align-items-center" *ngIf="option.email && option.email.trim() !== ''">
                                    <i class="fa fa-envelope me-2 text-secondary"></i>
                                    <span class="text-truncate">{{option.email}}</span>
                                </div>
                                <div class="text-muted small d-flex align-items-center" *ngIf="option.telefone && option.telefone.trim() !== ''">
                                    <i class="fa fa-phone me-2 text-secondary"></i>
                                    <span class="text-truncate">{{option.telefone}}</span>
                                </div>
                            </div>
                        </div>
                        </mat-option>
                    </mat-autocomplete>

                    <div *ngFor="let option of clientesEscolhidos" class="form-check" style="margin-top: 10px;">
                      <div class="d-flex justify-content-between"  >
                        <div>
                          <span style="padding-right: 5px;">{{option.nome}}</span>  <span class="badge text-bg-dark">{{option.email}}</span>
                        </div>
                        <div>
                          <i class="fa fa-trash" aria-hidden="true" (click)="removeFromSelectedClients(option)"></i>
                        </div>
                      </div>
                    </div>
              </div>
            </div>
            <div  *ngIf="isChat || whatsAppEmAtendimento">
              <h3> Solicitante </h3>
              <div *ngFor="let option of clientesEscolhidos" class="form-check" style="margin-top: 10px;">
                <div class="d-flex justify-content-between"  >
                  <div>
                    <span style="padding-right: 5px;">{{option.nome}}</span>  <span class="badge text-bg-dark">{{option.email}}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Responsavel-->
            <h3 class="mt-3">
                Responsável
            </h3> 
            <app-realdesk-autocomplete
                [isLoading]="isLoadingResponsaveis"
                [filteredOptions]="filteredResponsaveisOptions"
                [control]="autocompleteResponsaveisControl"
                [placeholder]="'Pesquisar nome de um operador'"
                [tooltip]="'Escolha o operador responsável pelo atendimento deste ticket.'"
                [initialValue]="selectedResponsible"
                (optionSelected)="onResponsibleSelected($event)"
            ></app-realdesk-autocomplete>

            <!-- Convidados no chat-->
            <div  *ngIf="operadoresConvidados.length > 0">
              <h3 class="mt-3"> Operadores Convidados </h3>
              <div *ngFor="let option of operadoresConvidados" class="form-check" style="margin-top: 10px;">
                <div class="d-flex justify-content-between"  >
                  <div>
                    <span style="padding-right: 5px;">{{option.nome}}</span>  <span class="badge text-bg-dark">{{option.email}}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- categoria -->
            <h3 class="mt-3">Categoria</h3>
            <app-realdesk-autocomplete
                [isLoading]="isLoadingCategorias"
                [filteredOptions]="filteredCategoriasOptions"
                [control]="getFormControl('autocompleteCategorias')"
                [placeholder]="'Selecione uma categoria'"
                [tooltip]="'Escolha a categoria em que esse ticket se enquadra'"
                [initialValue]="selectedCategory"
                [displayProperty]="'name'"
                (optionSelected)="onCategoriaSelected($event)"
            ></app-realdesk-autocomplete>

            <!-- Urgencia -->
            <h3 class="mt-3">Urgência</h3>
            <app-realdesk-autocomplete
                [isLoading]="isLoadingUrgencias"
                [filteredOptions]="filteredUrgenciasOptions"
                [control]="getFormControl('autocompleteUrgencias')"
                [placeholder]="'Selecione uma Urgência'"
                [tooltip]="'Opcionalmente, você pode dar uma urgência a este ticket para qualificá-lo melhor.'"
                [initialValue]="selectedUrgency"
                [displayProperty]="'name'"
                (optionSelected)="onUrgenciaSelected($event)"
            ></app-realdesk-autocomplete>

            <!-- Tags -->
            <h3 class="mt-3">Tags</h3>
            <app-realdesk-autocomplete
                [isLoading]="isLoadingTags"
                [filteredOptions]="filteredTagsOptions"
                [control]="getFormControl('autocompleteTags')"
                [placeholder]="'Adcione uma tag a esse ticket'"
                [tooltip]="'Opcionalmente, você criar uma nova tag ou escolher uma tag já existente para classificar o ticket'"
                [initialValue]="undefined"
                [displayProperty]="'name'"
                (optionSelected)="onTagSelected($event)"
            ></app-realdesk-autocomplete>

            <div *ngFor="let option of tagsEscolhidas" class="badge text-bg-warning" style="margin-top: 10px; margin-right: 5px;">
                <div class="d-flex justify-content-between" style="margin-right: 5px;">
                    <div>
                        <span>{{option.name}}</span>
                    </div>
                    <div>
                        <i class="fa fa-trash" aria-hidden="true" (click)="removeFromSelectedTags(option)"></i>
                    </div>
                </div>
            </div>

            <!-- CC -->
            <h3 class="mt-3">Cópia para outro cliente:</h3>
            <div class="col-md-12 mb-3 search-bar" style="margin-left:0"
             matTooltip="Aqui você pode criar uma cópia deste ticket para outro cliente. Essa cópia gera um novo ticket exclusivo para esse cliente."
            >
                <input 
                    type="text" 
                    class="form-control" 
                    placeholder="Buscar Cópia" 
                    matInput 
                    style="width:100%;"
                    formControlName="autocompleteSolicitanteCopia"
                    [matAutocomplete]="autoSolicitanteCopia">
                <mat-autocomplete autoActiveFirstOption #autoSolicitanteCopia="matAutocomplete" (optionSelected)="onSolicitanteCopiaSelected($event)" [displayWith]="displayFn">
                <mat-option *ngFor="let option of solicitateCopiaFilteredOptions | async" [value]="option">
                    <div class="d-flex flex-column p-2">
                        <div class="fw-semibold text-primary mb-1">{{option.nome}}</div>
                        <div class="d-flex flex-column gap-1">
                            <div class="text-muted small d-flex align-items-center" *ngIf="option.email && option.email.trim() !== ''">
                                <i class="fa fa-envelope me-2 text-secondary"></i>
                                <span class="text-truncate">{{option.email}}</span>
                            </div>
                            <div class="text-muted small d-flex align-items-center" *ngIf="option.telefone && option.telefone.trim() !== ''">
                                <i class="fa fa-phone me-2 text-secondary"></i>
                                <span class="text-truncate">{{option.telefone}}</span>
                            </div>
                        </div>
                    </div>
                </mat-option>
                </mat-autocomplete>

                <div *ngFor="let option of clientesCopiaEscolhidos" class="form-check" style="margin-top: 10px;">
                    <div class="d-flex justify-content-between"  >
                        <div>
                            <span style="padding-right: 5px;">{{option.nome}}</span>  <span class="badge text-bg-dark">{{option.email}}</span>
                        </div>
                        <div>
                            <i class="fa fa-trash" aria-hidden="true" (click)="removeFromSelectedClientsCopia(option)"></i>
                        </div>
                    </div>
                </div>

                
            </div>


            <div *ngIf="(isChat && logadoIsResponsavel) || (whatsAppEmAtendimento)">
              <hr>
              <button  class="btn btn-primary" style="margin-top: 10px; width: 100%" (click)="salvarChat()"
               matTooltip="Você pode classificar melhor seu chat utilizando as opções acima e, em seguida, salvar clicando neste botão."
            >
                <i class="fa fa-close" aria-hidden="true"></i> Salvar
              </button>
            </div>
            

            <!-- <h3 class="mt-3">Previsão de solução</h3>
            <select class="form-select" aria-label="Default select example">
                <option selected>Selecione</option>
            </select>
            <a href="#" class="btn btn-secondary mt-4 icon">
                <span>
                    <img src="../../../../assets/images/icon-plus.svg">
                </span>
                Mostrar mais
            </a> -->
        </div>
    </div>

    <div class="col-md-9"  *ngIf="isLoadingOnOpen">
      <i class="fa fa-spin fa-spinner me-2" aria-hidden="true"></i> 
    </div>
    <div class="col-md-9"  *ngIf="!isLoadingOnOpen">
        <div class="card content" *ngIf="whatsAppEmAtendimento">
          <div class="whatsapp-redirect-container">
            <div class="whatsapp-icon">
              <i class="fab fa-whatsapp fa-5x" style="color: #25D366;"></i>
            </div>
            <div class="whatsapp-message">
              <h2>Atendimento via WhatsApp</h2>
              <p>Este atendimento está sendo realizado em nossa plataforma WhatsApp. Clique no botão abaixo para acessar a conversa.</p>
              <a [routerLink]="['/whatsapp/chat']" class="whatsapp-redirect-button">
                <i class="fab fa-whatsapp"></i>
                Ir para WhatsApp
              </a>
            </div>
          </div>
        </div>
        <div class="card content" *ngIf="!whatsAppEmAtendimento">
            <div class="row" *ngIf="!isChat">
                <!-- Origem -->

                <div class="col-md-2">
                  <div class="form-check"
                      [ngClass]="{'form-check-ticket-actions': realDeskForm.get('ticketPublico')?.value === true}"
                       matTooltip="Seu ticket será público, seu cliente será notificado quando você adicionar uma ação"
                      (click)="setTicketPublico(true)"
                  >
                      <input
                          class="form-check-input"
                          type="radio"
                          id="acaoPublica"
                          formControlName="ticketPublico"
                          [value]="true"
                          (click)="$event.stopPropagation()" 
                      >
                      <label class="form-check-label" for="acaoPublica">
                          Ação Pública
                      </label>
                      <i class="fa fa-star font-primary" style="margin-left: 5px;"></i>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-check" 
                      [ngClass]="{'form-check-ticket-actions': realDeskForm.get('ticketPublico')?.value === false}"
                       matTooltip="Seu ticket será interno, seu cliente não será notificado quando você adicionar uma ação, somente os operadores terão acesso à sua resposta" 
                      (click)="setTicketPublico(false)"
                  >
                      <input
                          class="form-check-input"
                          type="radio"
                          id="acaoInterna"
                          formControlName="ticketPublico"
                          [value]="false"
                          (click)="$event.stopPropagation()" 
                      >
                      <label class="form-check-label" for="acaoInterna">
                          Ação Interna
                      </label>
                      <i class="fa fa-lock font-primary" style="margin-left: 5px;"></i>
                  </div>
                </div>

                <!-- Status -->
                <div class="col-md-8" *ngIf="!ticketNovo">
                    <div class="col-md-12 mb-3 status-bar" 
                    style="margin-left:0;   border: 1px solid #002C6B; border-radius: 8px;"
                     matTooltip="Troque aqui o status do seu ticket"
                    >
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Selecione o status do ticket"
                            style="width:100%;"
                            matInput
                              formControlName="autocompleteStatus"
                              [matAutocomplete]="autoStatus"
                        >
        
                        <mat-autocomplete #autoStatus="matAutocomplete" [displayWith]="displayStatus" (optionSelected)="onStatusChanged($event)">
                            @for (option of filteredStatusOptions | async; track option) {
                              <mat-option [value]="option">{{option.name}}</mat-option>
                            }
                          </mat-autocomplete>
                    </div>
                </div>

            </div>

            <div class="row" *ngIf="isChat && logadoIsResponsavel">
              
              <!-- Status -->
              <div class="col-md-6" >

                <button type="button" class="btn btn-secondary" style="margin-right: 20px;"  data-bs-toggle="modal" data-bs-target="#addTransferirChatModal"
                 matTooltip="Você pode transferir para outra equipe definida em assuntos" >
                <i class="fas fa-exchange-alt"></i>  Transferir Chat
                </button>

                <button class="btn btn-secondary" style="margin-right: 20px;" (click)="encerrarChat()" 
                 matTooltip="O atendimento será encerrado tanto para você quanto para o seu cliente. Logo após, este chat será convertido em um ticket, e uma cópia será enviada para o cliente por e-mail."
                >
                <i class="fas fa-times"></i>  Encerrar Chat
                </button>

                <button class="btn btn-secondary" *ngIf="canLeaveChat" (click)="leaveChat()" 
                 matTooltip="Se tiver outro agente no atendimento, você pode sair do atendimento. O seu cliente sera notificado em tela">
                <i class="fas fa-sign-out-alt"></i> Sair do Chat 
                </button>


              </div>

              <!-- Status -->
              <div class="col-md-6" *ngIf="!ticketNovo">
                <div class="col-md-12 mb-3 status-bar" 
                style="margin-left:0;   border: 1px solid #002C6B; border-radius: 8px;"
                 matTooltip="Troque aqui o status do seu ticket"
                >
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Selecione o status do ticket"
                        style="width:100%;"
                        matInput
                          formControlName="autocompleteStatus"
                          [matAutocomplete]="autoStatus"
                    >
    
                    <mat-autocomplete #autoStatus="matAutocomplete" [displayWith]="displayStatus" (optionSelected)="onStatusChanged($event)">
                        @for (option of filteredStatusOptions | async; track option) {
                          <mat-option [value]="option">{{option.name}}</mat-option>
                        }
                      </mat-autocomplete>
                </div>
              </div>
            </div>

            <div class="row">
                <!--Assunto-->
                <div class="col-md-12 mt-3" *ngIf="!ticketNovo">
                  
                    <div class="ticket-header-info">
                      <span class="ticket-header-client">
                        <i class="fa fa-comments"></i>
                        Chat com cliente <strong>{{realDeskForm.controls['nomeCliente'].value}}</strong>
                        <span class="badge bg-dark ms-2">{{realDeskForm.controls['emailCliente']?.value || ''}}</span>
                      </span>
                      <span class="ticket-header-date">
                        <i class="fa fa-calendar"></i>
                        {{realDeskForm.controls['origem'].value}} aberto em 
                        {{realDeskForm.controls['dataAbertura'].value  | date:'dd/MM/yyyy'}} {{realDeskForm.controls['dataAbertura'].value  | date:'HH:mm'}}
                      </span>
                      <span class="ticket-header-app" *ngIf="isChat">
                        <i class="fa fa-mobile-alt"></i>
                        Aplicativo <strong>{{aplicativo}}</strong>
                      </span>
                      <span class="ticket-header-assunto" *ngIf="isChat">
                        <i class="fa fa-tag"></i>
                        Assunto: <strong>{{assunto}}</strong>
                      </span>
                    </div>
                </div>
                <div class="col-md-12 mt-3" *ngIf="ticketNovo">
                  <input
                  type="text"
                  class="form-control"
                  placeholder="Assunto do ticket"
                  style="width:100%;"
                  formControlName="assunto"
              >
              </div>
            </div>
            
            <!-- WYSIWYG -->
            <div class="row">
                <div class="col-md-12" >
                      <!-- <textarea class="form-control" id="exampleFormControlTextarea1" rows="10"></textarea> -->
                      <div class="NgxEditor__Wrapper" *ngIf="!isChat">
                        <ngx-editor-menu [editor]="editor"  [toolbar]="toolbar"[colorPresets]="colorPresets"> </ngx-editor-menu>
                        <ngx-editor 
                          [editor]="editor" 
                          [ngModel]="html" 
                          [disabled]="false" 
                          [placeholder]="'Escreva aqui o texto do seu atendimento'" 
                          formControlName="htmlContent"
                          class="NgxEditor__Content"></ngx-editor>
                      </div>
                      <div *ngIf="isChat">
                        <app-chat-box [ticketId]="ticketId" [logadoIsResponsavel]="logadoIsResponsavel" [chats]="chats" [messageInput]="chatMessage" (taskRequestedChatEncerrado)="executeTaskEmitChatEncerrado()" (taskChatInvitation)="executeTaskChatInvitation()"></app-chat-box>
                        
                      </div>
                </div>
            </div>
            
            <!-- opcoes extras -->
            <div class="row" >
              <div class="col-sm-12 col-md-12">
                <div class="mb-3" style=" display: flex;justify-content: space-between;  padding: 5px;" >
                  <div style="display: flex;">
                    <div  *ngIf="!isChat">
                      <input type="file"  #fileInput style="display: none"  (change)="onFileSelected($event)">

                      <button class="btn btn-primary" style="margin: 10px;" (click)="fileInput.click()"  matTooltip="Adcione um arquivo anexo ao seu ticket">
                        <i class="fa fa-paperclip" *ngIf="!isLoading" aria-hidden="true"></i>
                        <i class="fa fa-spin fa-spinner me-2" *ngIf="isLoading" aria-hidden="true"></i>
                      </button>
                      <!-- <button class="btn-secondary"  style="margin: 10px;" (click)="addAttachAlreadyInThisTicket()" >
                        <i class="fa fa-paperclip" aria-hidden="true"></i>
                      </button> -->
                    </div>
                    <div *ngIf="isChat && logadoIsResponsavel" >
                      <button class="btn btn-primary"   matTooltip="Use a base de conhecimento" style="margin: 10px;" (click)="openKnowledgeBase()">
                        <i class="fas fa-book"></i> <!-- Ícone de base de conhecimento -->
                      </button>
                    </div>

                    <div *ngIf="!isChat">
                      <button class="btn btn-primary"   matTooltip="Use a base de conhecimento" style="margin: 10px;" (click)="openKnowledgeBase()">
                        <i class="fas fa-book"></i> <!-- Ícone de base de conhecimento -->
                      </button>
                    </div>
                    
                    <div *ngIf="!isChat">
                      <button class="btn btn-primary" style="margin: 10px;" (click)="addKnowledgeBase()"  matTooltip="Responda seu ticket utilizando uma resposta automaticamente gerada">
                        <!-- <i class="fa fa-book" aria-hidden="true"></i> -->
                        Usar inteligência artificial
                      </button>
                    </div>

                    <div *ngIf="isChat && logadoIsResponsavel" style="display: flex;"  class="search-bar" style="margin-left: 0;  margin: 10px;"  matTooltip="Responda o ticket com alguma macro criada, digitando o inicio da macro aparecera o seu conteudo">
                        <input type="text" class="form-control" placeholder="Adcionar Macro ao ticket" aria-label="Number" matInput formControlName="autocompleteMacros" [matAutocomplete]="autoMacro">
                        <mat-autocomplete autoActiveFirstOption #autoMacro="matAutocomplete" (optionSelected)="onMacroSelectChange($event)" [displayWith]="displayMacro">
                     
                         <mat-option *ngFor="let option of filteredMacrosOptions | async" [value]="option">
                            {{option.name}}
                          </mat-option>
                        </mat-autocomplete>
                    </div>
                  </div>
                  <div *ngIf="!isChat">
                      <button class="btn btn-primary" type="submit" style="margin: 10px;"   [disabled]="isLoading" (click)="create()"  matTooltip="Ao clicar nesse botao, seu ticker sera respondido">
                        <i *ngIf="isLoading" class="fa fa-spin fa-spinner me-2"></i>
                        Adcionar Ação
                      </button>
                  </div>
                </div>
              </div>
              <!-- Arquivos Anexados -->
              <div class="row">
                    <div class="col-md-3 badge text-bg-dark" style="margin: 5px" *ngFor="let option of arquivosAnexados">
                      
                      <div  matTooltip="{{option.name}}">
                        <a [href]="option.link" target="_blank" style="color: white;">
                          <i class="fa fa-paperclip" aria-hidden="true"></i>
                          <span>{{ option.name.length > 20 ? (option.name | slice:0:20) + '...' : option.name }}</span>
                          <br>
                          <span>{{option.size | number:'.2'}} Mb</span>
                        </a>
                      </div>
                      <div>
                        <i class="fa fa-trash" aria-hidden="true" (click)="removeFromAttach(option)"></i>
                      </div>
                    </div>
                  
              </div>
            </div>

           
            <div class="row" style="border: 1px solid #E5E5E5; border-radius:12px; padding-top: 10px;;">
              <div class="col-md-12" >
                <label class="form-label">Tickets relacionados</label> 
                <i 
                  [ngClass]="ticketsRelacionadosJaPesquisado ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" 
                  style="cursor: pointer; margin-left: 10px;" 
                  (click)="toggleTicketsRelacionados()"
                  aria-hidden="true"
                ></i>
                </div>
              <div 
                  class="col-md-12 tickets-relacionados-content" 
                  *ngIf="ticketsRelacionadosJaPesquisado" 
                  [@slideInOut]="ticketsRelacionadosJaPesquisado ? 'in' : 'out'"
                >
                <button class="btn btn-primary" type="submit" style="margin: 10px;"   [disabled]="isLoading" (click)="openTicketRelacionadoModal()"  matTooltip="Abre a janela para relacionar um ticket">
                  <i *ngIf="isLoading" class="fa fa-spin fa-spinner me-2"></i>
                  Relacionar tickets
                </button>
                <table *ngIf="ticketRelacionados.length > 0" class="table table-striped table-hover table-borderless" data-cy="table-list">
                  <thead>
                      <tr>
                        <th scope="col">Número</th>
                        <th scope="col">Assunto</th>
                        <th scope="col">Aberto em</th>
                        <th scope="col">Cliente</th>
                        <th scope="col">Responsável</th>
                        <th scope="col">Categoria</th>
                        <th scope="col">Status</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (data of ticketRelacionados; track data) {
                        <tr [routerLink]="['/tickets', data.numero, 'edit']" style="cursor: pointer" >
                          <td >
                            <a  [routerLink]="['/tickets', data.numero, 'edit']" href="#">
                              {{data.numero}}
                              <br>
                              <span class="badge text-bg-light">{{data.origem}}</span>
                            </a>
                          </td>
                          <td>
                            {{data.assunto}}
                            
                            <div style="display: flex; align-items: center;"  *ngIf="data.corUrgencia" title="Urgencia">
                              <div style="width: 20px; height: 20px; border-radius: 50%; background-color: {{data.corUrgencia}}; margin-right: 1px;"></div>
                              <span class="badge text-bg-light">{{data.urgencia}}</span>
                            </div>
                          </td>
                          <td>
                            <img src="../../../../assets/images/icon-date-table.svg" class="me-2">{{data.dataAbertura | date:'dd/MM/yyyy' }}
                              <br>
                            <img src="../../../../assets/images/icon-clock-table.svg" class="me-2">{{data.horaAbertura| date:'HH:mm' }}
                          </td>
                          <td>
                            {{data.nomeCliente}}
                          </td>
                          <td>
                            {{data.operadorResponsavel}}
                          </td>
                          <td>
                            {{data.categoria}}
                          </td>
                          <td>
                            {{data.status}}
                          </td>
                          <td (click)="$event.stopPropagation()">
                            <i aria-hidden="true" class="fa fa-trash"  style="cursor: pointer" (click)="removerAssociacao(data.numero)"
                             matTooltip="Exclui o relacionamento do ticket" 
                            ></i>
                          </td>
                        </tr>
                      }
                    </tbody>
                </table>  
                <div *ngIf="ticketRelacionados.length == 0">
                  <p>Nao existem tickets relacionados</p>
                </div>         
              </div>
            
            </div>
        </div>
      <!-- atendimentos -->
      <div class="timeline-content">

          <div  *ngFor="let atendimento of atendimentos">
            <div class="your-message">
              <div class="d-flex">
                <div>
                  <img style="margin-top: 15px; border-radius: 5px;;" alt="" src="../../../assets/images/avatar.png">
                </div>

                <div class="card content" style="margin:10px">
                  <div >
                    <div>
                      <strong>{{atendimento.operadorResponsavel}}</strong> 
                      <span>{{atendimento.assunto}}</span>
                      <span>{{formatDate(atendimento.dataAbertura) | date:'dd/MM/yyyy'}} {{formatDate(atendimento.dataAbertura) | date:'HH:mm'}}</span>
                      <div style="text-align: end;">
                        <span class="badge text-bg-secondary"> {{atendimento.origem}}</span>  
                        <span *ngIf="atendimento.flagPrivado" class="badge text-bg-dark"> Interno
                          <i class="fa fa-lock font-primary"></i>
                        </span>  
                        <span *ngIf="!atendimento.flagPrivado" class="badge text-bg-warning"> Pública
                          <i class="fa fa-star font-primary"></i>
                        </span>
                      </div>
                    </div>
                    
                    <!-- <div>
                      <i class="fa fa-pencil" aria-hidden="true" (click)="addKnowledgeBase()"></i>
                      <i class="fa fa-book" aria-hidden="true" (click)="addKnowledgeBase()"></i>
                    </div> -->
                  </div>
                  
                  <div [innerHTML]="atendimento.htmlContent"   class="inner-html-content">
                  </div>
                  <div>
                    <a *ngFor="let anexo of atendimento.anexos" [href]="anexo.url" target="_blank" >
                      <i class="fa fa-paperclip" aria-hidden="true"><span>{{anexo.nome}}</span></i>
                    </a>
                  </div>

                </div>

              </div>
            </div>
            <!-- <ul class="blog-social">
              <li  *ngFor="let status of atendimento.listaStatus"><i class="icofont icofont-user"></i>{{status.usuario}}: {{status.nome}} <i>{{status.data}}</i></li>
          </ul> -->
          </div>


      </div>
      <!-- Botao Salvar -->
    </div>



<!-- Modal para adicionar operadores -->
<div class="modal fade" id="addTransferirChatModal" tabindex="-1" aria-labelledby="addTransferirChatModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addTransferirChatModallLabel">Transferir Chat</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <select class="form-select" id="idMenu" formControlName="chatGroupId" >
          <option *ngFor="let option of allGroupChats" [value]="option.id">{{option.nome}}</option>
        </select>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="transferirChatClick()" data-bs-dismiss="modal">Transferir</button>
      </div>
    </div>
  </div>
</div>

</form>

